'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'books';
var width = 512;
var height = 512;
var aliases = [128218];
var unicode = 'f5db';
var svgPathData = 'M510.4 435.4l-107.7-399.9C396.9 14.08 377.5 0 356.4 0c-4.111 0-8.294 .5313-12.46 1.641l-61.82 16.48c-5.885 1.57-11.14 4.258-15.78 7.633C258.3 10.51 242.4 0 224 0H160C151.2 0 143.1 2.531 136 6.656C128.9 2.531 120.8 0 112 0h-64C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h64c8.787 0 16.92-2.531 24-6.656C143.1 509.5 151.2 512 160 512h64c26.51 0 48-21.49 48-48V165.3l83.8 311.3C361.6 497.9 380.9 512 402.1 512c4.111 0 8.293-.5313 12.46-1.641l61.82-16.48C502 487 517.2 460.8 510.4 435.4zM224 48V96L160 96L160 48H224zM160 144h64v224H160V144zM112 368h-64v-224h64V368zM112 48V96h-64V48H112zM48 464V416h64v48H48zM160 464l.0011-47.1L224 416v48H160zM294.4 64.5l61.83-16.48l12.47 45.91L306.8 110.4L294.4 64.5zM319.3 156.6l61.91-16.51l58.04 215.3l-61.91 16.51L319.3 156.6zM402.2 464.1l-12.41-46.04l61.91-16.51l12.38 45.94L402.2 464.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBooks = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;